import { formatDistanceToNow } from 'date-fns'
import { activeDateFnsLocale } from 'features/locale/dateFnsLocale'

export function formatRelativeTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: activeDateFnsLocale(),
  })
}
